import { render, staticRenderFns } from "./ExpertManage.vue?vue&type=template&id=1a7b2200&scoped=true&"
import script from "./ExpertManage.vue?vue&type=script&lang=js&"
export * from "./ExpertManage.vue?vue&type=script&lang=js&"
import style0 from "./ExpertManage.vue?vue&type=style&index=0&id=1a7b2200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7b2200",
  null
  
)

export default component.exports